export function afterOverlayClose(fn: () => void) {
  const duration = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--ui-speed') ?? 0);
  setTimeout(() => {
    fn();
  }, duration + 150);
}
